import * as React from 'react';
import { Tooltip } from 'reactstrap';

export interface IIconTooltipProps {
    onClick?: () => any;
    icon: string;
    id: string;
    placement: any;
    autoHide: boolean;
    text: string;
    className?: string;
}

export interface IIconTooltipState {
    isOpen: boolean;
}

export class IconTooltip extends React.Component<IIconTooltipProps, IIconTooltipState> {
    constructor(props: IIconTooltipProps) {
        super(props);

        this.state = {
            isOpen: false
        }
    }
    public toggle = () => {
        this.setState((state) => ({ isOpen: !state.isOpen }))
    }

    public render() {
        const id = this.props.id.replace(/[^\w\s]/gi, '') // change id to match valid id
        return (
            <>
                <i id={id} className={`fa fa-${this.props.icon} ${this.props.className}`} onClick={this.props.onClick} />
                <Tooltip placement={this.props.placement} isOpen={this.state.isOpen} autohide={false} target={id} toggle={this.toggle}>
                    {this.props.text}
                </Tooltip>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/share/components/IconTooltip/IconTooltip.tsx